import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

const WholePortionPredriedPreparationSectionBase: React.FC<IWorksheetComponent> = () => (
  <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
    <ListFieldSection>
      {/* The same balance is used to measure TareMass and TareAndDryMass. Copying
      the value is a simple workaround that avoids implementing a config function
      for `measuredUsing`.  */}
      <WorksheetBalanceFieldSet name="Equipment.Balance" copyTo={['Equipment.DryMassBalance']} />
      <Field input={<NumericInput />} name="TareMass" />
      <Field input={<NumericInput />} name="TareAndDryMass" />
      <Field input={<TextOutput />} name="DryMass" />
    </ListFieldSection>
  </NamePrefixModifier>
);
const WholePortionPredriedPreparationSection = withInjectedProps(WholePortionPredriedPreparationSectionBase);

export { WholePortionPredriedPreparationSection };
export default WholePortionPredriedPreparationSection;
